<template>
  <div class="user-generated-html-content" v-html="decodedHtml"></div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
});

const decodedHtml = computed(() => {
  if (!props.content) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = props.content;
  return textarea.value;
});
</script>

<style lang="scss" scoped>
.user-generated-html-content {
  :deep(table) {
    th, td {
      padding: 15px;
      text-align: left;
    }
  }
}
</style>
